import { Box, Button, Flex, Icon, Image, Text } from '@chakra-ui/react';
import { useReducer } from 'react';

import { FiCheckSquare } from 'react-icons/fi';
import { FiGrid } from 'react-icons/fi';
import { useStepPhotoManager } from '../../../contexts/StepPhotoManagerContext';
import { InitialStep } from './steps/InitialStep';
import { AiOutlineArrowLeft } from 'react-icons/ai';
import { FotoPedidoStep } from './steps/FotoPedidoStep';
import { UploadFotosPedido } from './steps/UploadFotosPedido';

const initialState = {
  step: 'Home'
};

function reducer(state, action) {
  switch (action.type) {
    case 'Home':
      return { step: 'Home' };
    case 'FotosPedido':
      return { step: 'FotosPedido' };
    case 'FotosGaleria':
      return { step: 'FotosGaleria' };
    case 'UploadFotosPedido':
      return { step: 'UploadFotosPedido' };
    case 'UploadFotosGaleria':
      return { step: 'UploadFotosGaleria' };
    case 'FinalizarPedido':
      return { step: 'FinalizarPedido' };

    default:
      return { step: 'Home' };
  }
}

export function PhotoManager() {
  const { steps, dispatch } = useStepPhotoManager();

  const conditionalRender = {
    Home: <InitialStep />,
    FotosPedido: <FotoPedidoStep />,
    FotosGaleria: <SecondStep />,
    UploadFotosPedido: <UploadFotosPedido />,
    UploadFotosGaleria: <SecondStep />,
    FinalizarPedido: <SecondStep />
  };

  return (
    <Box
      display={{ base: 'flex', md: 'flex' }}
      flexDir="column"
      fontFamily="Open Sans, sans-serif"
      bg="#F5F5F5">
      {conditionalRender[steps.step]}
    </Box>
  );
}

function SecondStep() {
  return (
    <Box>
      <Text>Second Step</Text>
    </Box>
  );
}
